import MigratableWorkoutsTable from './MigratableWorkoutsTable';

export default MigratableWorkoutsTable;
